// «Условия перехода» of a pipeline stage (R-C14, as in amoCRM): fields that must be filled, a reason and «Запретить изменение» (R-T4).

import { useState } from 'react';
import type { FieldDef, Id } from '@confdeck/core-shared';
import { useMeta, useSync } from '../sync/react.tsx';
import { Button, Checkbox, Dialog, useToast } from '../ui/primitives.tsx';
import s from './stage-rules.module.css';

export function StageRules({ termId, onClose }: { termId: Id; onClose: () => void }) {
  const meta = useMeta();
  const client = useSync();
  const toast = useToast();
  const t = meta.term(termId)!;
  const [reason, setReason] = useState(!!t.rules?.reason);
  const [lock, setLock] = useState(!!t.rules?.lock);
  const [fields, setFields] = useState<Id[]>(t.rules?.fields ?? []);
  // Fields of the sections whose stage field takes this pipeline; computed and app-managed fields are filled by actions, not people.
  const stageFields = meta.types().flatMap((ty) => meta.fields(ty.id).filter((f) => f.fieldType === 'taxonomy' && f.options.taxonomyId === t.taxonomyId).map(() => ty));
  const groups = [...new Map(stageFields.map((ty) => [ty.id, ty])).values()].map((ty) => ({
    type: ty, fields: meta.fields(ty.id).filter((f: FieldDef) => !f.options.managed && !(f.fieldType === 'taxonomy' && f.options.taxonomyId === t.taxonomyId)),
  }));
  const save = async () => {
    const r = await client.run('term.setRules', { id: t.id, reason, lock, fields });
    if (r.ok) { toast({ kind: 'info', text: `Условия этапа «${t.name}» сохранены` }); onClose(); } else toast({ kind: 'error', text: r.error.message });
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()} label={`Условия перехода: ${t.name}`}>
      <div className={s.dialog}>
        <h2 className={s.dialogTitle}>Условия перехода на этап «{t.name}»</h2>
        <p className={s.help}>Запись не перейдёт на этап, пока условия не выполнены: система попросит дополнить.</p>
        <Checkbox checked={reason} onChange={setReason}>Нужна причина перехода</Checkbox>
        <Checkbox checked={lock} onChange={setLock}>Запретить изменение записи на этом этапе</Checkbox>
        {lock && <p className={s.help}>Кто всё же может править такие записи — настройка «Правка закрытых этапов». Действия со своим правом (аннулировать, вернуть деньги), сценарии и оплата работают всегда.</p>}
        {groups.map((g) => (
          <div key={g.type.id} className={s.permGroup}>
            <div className={s.permHead}>Обязательные поля · {g.type.nameMany}</div>
            <div className={s.fieldList}>
              {g.fields.map((f) => (
                <Checkbox key={f.id} checked={fields.includes(f.id)} onChange={(on) => setFields(on ? [...fields, f.id] : fields.filter((x) => x !== f.id))}>{f.name}</Checkbox>
              ))}
            </div>
          </div>
        ))}
        <div className={s.actions}><span className={s.spacer} /><Button onClick={onClose}>Отмена</Button><Button variant="primary" onClick={() => void save()}>Сохранить</Button></div>
      </div>
    </Dialog>
  );
}
